const Envs = {
  API_URL: process.env.REACT_APP_API_URL,
  MONITORING_KEY: '',
  ALS_IDENTITY_POOL_ID: process.env.REACT_APP_ALS_IDENTITY_POOL_ID,
  AWS_MAP_NAME: process.env.REACT_APP_AWS_MAP_NAME,
  REACT_APP_LOGIN_URL: process.env.REACT_APP_LOGIN_URL,
}

export default Envs
